import { IconInfoCircleOutline } from '@iwoca/icons';
import { Text } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';
export const MobileAppWidget = () => {
    return (
        <div className="my-2xl w-fit rounded-l bg-primary-97 p-xl">
            <Text className="mb-m text-l font-med max-sm:text-m">
                <FormattedMessage
                    id="_.credit_card.dashboard.mobile_app_title"
                    defaultMessage="View your card details and manage your card on the mobile app."
                />
            </Text>

            <div className="flex flex-row items-center gap-m">
                {/* App Store Section */}
                <a
                    href="https://apps.apple.com/gb/app/iwoca/id6757226535"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="transition-opacity hover:opacity-80"
                >
                    <img
                        src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83"
                        // eslint-disable-next-line formatjs/no-literal-string-in-jsx
                        alt="Download on the App Store"
                        className="h-[60px] w-auto max-sm:h-[40px]"
                    />
                </a>

                {/* Google Play Section */}
                <a
                    href="https://play.google.com/store/apps/details?id=com.iwoca.wallet&hl=en_GB"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="transition-opacity hover:opacity-80"
                >
                    <img
                        src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
                        // eslint-disable-next-line formatjs/no-literal-string-in-jsx
                        alt="Get it on Google Play"
                        className="h-[87px] w-auto max-sm:h-[58px]"
                    />
                </a>
            </div>

            {/* Info Banner */}
            <div className="bg-structure-50 mt-m flex max-w-md items-start gap-xs rounded-xs border border-secondary-80 p-m">
                <IconInfoCircleOutline className="my-auto" />
                <Text className="text-s font-med">
                    <FormattedMessage
                        id="_.credit_card.dashboard.virtual_card_info"
                        defaultMessage="Your virtual card will be available to use immediately."
                    />
                </Text>
            </div>
        </div>
    );
};
